// setRecentSearchHashtag.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Set recent search hashtag
 * @kind action
 * @param {string} {query} - query to store in browser.
 * @return {Promise} Action promise.
 */
const setRecentSearchHashtag =
  ({ query }) =>
  (dispatch, getState) => {
    if (!query) return dispatch({ type: '' });
    const searchHistoryQueue =
      getOperationData(getState(), ['search'], 'recentSearchHashtags') || [];

    const newSearchHistoryQueue = [
      ...new Set([query, ...searchHistoryQueue]),
    ].slice(0, 5);

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['search'],
        data: {
          recentSearchHashtags: newSearchHistoryQueue,
        },
      },
    });
  };

export default setRecentSearchHashtag;
